module.exports = __webpack_public_path__ + "img/debatePresi20194.209fcec3.jpg";